import React from "react";
import Home from "./Home";
import Footer from "./Footer";
import Ban from "./Ban";
// import { Routes, Route } from "react-router-dom";

export default function Movies() {
  return (
    <>
      <Home
        imd1="8.5"
        link1="../Sololev"
        img1="https://i.postimg.cc/Sx7Q0VYb/solo.jpg"
        name1="Solo Leveling Hindi Dubbed"
        // 2 start
        imd2="1.0"
        link2="../Jjk"
        img2="https://a.storyblok.com/f/178900/2000x3000/8863dbd7c8/jujutsu-kaisen-season-2-key-art.png/m/filters:quality(95)format(webp)"
        name2="Jujutsu Kaisen Hindi Dubbed"
        // 3 start
        imd3="7.5"
        link3="../Mash"
        img3="https://a.storyblok.com/f/178900/849x1200/3ea3addb7a/mashle-s2-kv.jpeg/m/filters:quality(95)format(webp)"
        name3="MASHLE: MAGIC AND MUSCLES"
        // 4 start
        imd4="1.0"
        link4="../Over"
        img4="https://m.media-amazon.com/images/M/MV5BNmI3MTQ2NjEtMWI1ZC00NDExLWI5MmEtMjJkYjJhMWQxOTEzXkEyXkFqcGdeQXVyNzYzNjg0NDk@._V1_FMjpg_UX1000_.jpg"
        name4="Dormone Movies Hindi Dubbed"
      />
      {/*home 2 row */}

      {/* home 3 row */}
      <Home
        imd1="1.0"
        img1="https://i.postimg.cc/pV9hDBB8/9txbe-JIHla2-QXW3b-Gi3pgj-Is-Vp5.jpg"
        name1="Mashle: Magic and Muscles"
        // 2 start
        imd2="1.0"
        img2="https://i.postimg.cc/hvhNMsb2/onesheet.jpg"
        name2="Mashle: Magic and Muscles"
        // 3 start
        imd3="1.0"
        img3="https://i.postimg.cc/vZy4wwwL/MV5-BM2-M1-Yzc5-OTMt-NWQx-YS00-NTg5-LThi.jpg"
        name3="Mashle: Magic and Muscles"
        // 4 start
        imd4="1.0"
        img4="https://i.postimg.cc/TYgtxBwr/86c177dc86ced1c46825f01e9d2b4fb7.jpg"
        name4="Mashle: Magic and Muscles"
      />
      {/* home 4 row */}

      <Home
        imd1="1.0"
        img1="https://i.postimg.cc/RVSBJ1HJ/127624.jpg"
        name1="Mashle: Magic and Muscles"
        // 2 start
        imd2="1.0"
        img2="https://i.postimg.cc/hv5Rq6tF/MV5-BN2-Vi-ZDJj-Nz-Mt-Yj-Iy-MC00-Mjlj-LTli.jpg"
        name2="Mashle: Magic and Muscles"
        // 3 start
        imd3="1.0"
        img3="https://i.postimg.cc/LsR7G23Y/MV5-BZj-Jl-Nz-E5-Yz-Et-Yz-Qw-YS00-NTBj-LTk5.jpg"
        name3="Mashle: Magic and Muscles"
        // 4 start
        imd4="1.0"
        img4="https://i.postimg.cc/cC4dWf73/MV5-BNz-Qw-ODI4-Y2-Yt-Nj-Fm-NC00-NTEx-LWE0.jpg"
        name4="Mashle: Magic and Muscles"
      />
      <Ban
        ban="https://static.crunchyroll.com/fms/desktop_large/1350x450/7c373e00-2f1c-4721-9392-406dca679e2d.png"
        link="../Oneplace"
      />
      <Home
        imd1="1.0"
        img1="https://i.postimg.cc/3N10ds4J/MV5-BMTJj-Zm-Q5-MGQt-MWU0-My00-ZTMz-LWFm.jpg"
        name1="Mashle: Magic and Muscles"
        // 2 start
        imd2="1.0"
        img2="https://i.postimg.cc/XY3DMd3f/evangeline-image.jpg"
        name2="Mashle: Magic and Muscles  "
        // 3 start
        imd3="1.0"
        img3="https://i.postimg.cc/jjP3v3tK/MV5-BZGVl-Y2-Zh-M2-It-MWIw-ZC00-Yj-U0-LWJj.jpg"
        name3="Mashle: Magic and Muscles  "
        // 4 start
        imd4="1.0"
        img4="https://i.postimg.cc/qRpwwk1X/MV5-BMzhi-Zm-I2-ZWIt-Mj-E2-Mi00-Yj-Q2-LTky.jpg"
        name4="Mashle: Magic and Muscles  "
      />

      <Home
        imd1="1.0"
        img1="https://www.boredpanda.com/blog/wp-content/uploads/2021/11/best-anime-series-28-61a6373893e83__700.jpg"
        name1="Mashle: Magic and Muscles"
        // 2 start
        imd2="1.0"
        img2="https://qph.cf2.quoracdn.net/main-qimg-02f2326990487629d7b2093bfa03dfad.webp"
        name2="Mashle: Magic and Muscles  "
        // 3 start
        imd3="1.0"
        img3="https://deadline.com/wp-content/uploads/2020/10/High-Rise-Invasion.jpg"
        name3="Mashle: Magic and Muscles  "
        // 4 start
        imd4="1.0"
        img4="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR0PNr2qT5DfM_kE12L0dStM-ZIO4S_j1ocKQ&usqp=CAU"
        name4="Mashle: Magic and Muscles  "
      />

      <Home
        imd1="1.0"
        img1="https://www.crunchyroll.com/imgsrv/display/thumbnail/480x720/catalog/crunchyroll/ebcd65fa9fb83580062e7052fa6ee5a5.jpe"
        name1="Mashle: Magic and Muscles"
        // 2 start
        imd2="1.0"
        img2="https://www.crunchyroll.com/imgsrv/display/thumbnail/480x720/catalog/crunchyroll/a5ebfaaf02d69d1c0b254f4a49c43082.jpe"
        name2="Mashle: Magic and Muscles  "
        // 3 start
        imd3="1.0"
        img3="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSfdtV9vUvVa9D7zfmPeMFN81FOj-Ttwkbeuw&usqp=CAU"
        name3="Mashle: Magic and Muscles  "
        // 4 start
        imd4="1.0"
        img4="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRlBwCuAPv0Sk0DDVrLnQnth-tUBdrGpBXN4w&usqp=CAU"
        name4="Mashle: Magic and Muscles  "
      />

      <Home
        imd1="1.0"
        img1="https://resizing.flixster.com/-XZAfHZM39UwaGJIFWKAE8fS0ak=/v3/t/assets/p10701949_b_v8_ah.jpg"
        name1="Mashle: Magic and Muscles"
        // 2 start
        imd2="1.0"
        img2="https://i.redd.it/7xsygpc6kzp91.png"
        name2="Mashle: Magic and Muscles  "
        // 3 start
        imd3="1.0"
        img3="https://m.media-amazon.com/images/M/MV5BOGZmYjdjN2UtNjAwZi00YmEyLWFhNTEtNjM1OTc5ODg0MGEyXkEyXkFqcGdeQXVyMTA1NjQyNjkw._V1_FMjpg_UX1000_.jpg"
        name3="Mashle: Magic and Muscles  "
        // 4 start
        imd4="1.0"
        img4="https://images.justwatch.com/poster/261523688/s592/season-2"
        name4="Mashle: Magic and Muscles  "
      />
      <Ban
        ban="https://static.crunchyroll.com/fms/desktop_large/1350x450/ca139c87-7da0-48dc-9ea6-add06cb2b28d.png"
        link="../Over"
      />
      <Home
        imd1="1.0"
        img1="https://m.media-amazon.com/images/M/MV5BZjZjNzI5MDctY2Y4YS00NmM4LTljMmItZTFkOTExNGI3ODRhXkEyXkFqcGdeQXVyNjc3MjQzNTI@._V1_.jpg"
        name1="Mashle: Magic and Muscles"
        // 2 start
        imd2="1.0"
        img2="https://m.media-amazon.com/images/M/MV5BZDZiZTZhMzgtYTY0ZC00OGUyLWE2NzgtMmM4MjA1YjUxN2YyXkEyXkFqcGdeQXVyMTA3MDk2NDg2._V1_.jpg"
        name2="Mashle: Magic and Muscles  "
        // 3 start
        imd3="1.0"
        img3="https://m.media-amazon.com/images/M/MV5BNThhYWViMjMtNDMzZC00YjliLTllYWYtYTdlOTM1MmNjMDE4XkEyXkFqcGdeQXVyNjAwNDUxODI@._V1_.jpg"
        name3="Mashle: Magic and Muscles  "
        // 4 start
        imd4="1.0"
        img4="https://images.justwatch.com/poster/302172788/s718/season-1.jpg"
        name4="Mashle: Magic and Muscles  "
      />

      <Footer />
    </>
  );
}
